import type { IData, resumeResponse } from "~/interfaces";
import { DateTime } from "luxon";
import { RESUME_EXPIRE_AFTER } from "~/utils/constants";

const data: IData = getThemeData();

export default defineNuxtPlugin(() => {
    return {
        provide: {
            loadResumeData: async (): Promise<resumeResponse> => {
                
                const token = getStateValue("resumeTokenID");
                const envType = getStateValue("envType");

                return new Promise((resolve, reject) => {

                    if (!token || token.length !== 36) reject(false);
                    if (!envType) reject(false);

                    $fetch(`${data.endpoints.server as string}/${token}/${envType}`,)
                    .then((response) => {
                        if (!response.success || !response.order) {
                            reject(false)
                        }
                        const updateDate = DateTime.fromMillis(response.order.UpdatedAt)
                        if (updateDate.plus(RESUME_EXPIRE_AFTER) < DateTime.now() ) {
                            reject(false)
                        }
                        if (response.order.Abandon !== true || response.order.Esito !== null) {
                            reject(false)
                        }
                        resolve(response.order)
                    })
                    .catch(function() {
                        reject(false)
                    })
                })

            }
        }
    }
})

